export default {
  version: '',
  text: '',
}
